module.exports = __webpack_public_path__ + "static/img/Landing Page.71055624.svg";